<template>
  <div>
    <PageHeader :title="isMobileDevice || isTabletDevice ? '':'賞与面談'" class="main-form">
      <template #title-header-content>
        <div class="flex-1 flex justify-end items-center">
          <!-- 年度検索 -->
          <div class="mr-2 mt-auto flex items-end">
            <input
              type="number"
              name="filterYear" 
              min="2024"
              max="2999"
              placeholder="年度 検索"
              class="py-2 border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900 font-bold w-20 text-center" 
              v-model="filter.year"
            /> 
            <div class="pl-1 pr-2 font-bold text-white text-sm">年度</div>
          </div>

          <!-- 期 -->
          <div class="mr-2 font-bold text-white self-center flex">
            <span class="text-4xl">{{ term }}</span>
            <span class="pl-1 pr-2 text-sm self-end">期</span>
          </div>

          <!-- 切替 -->
          <div class="bg-white rounded mr-5">
            <div class="flex items-center py-1 rounded mx-5 ">
              <div v-for="tab in periodList" 
                :key="tab.id" 
                class="w-28 text-center mx-1 cursor-pointer"
                :class="[period == tab.id ? 'bg-light-blue-700' : 'hover:bg-gray-400', 'bg-gray-300 rounded-md py-1 px-3 text-sm font-medium text-white']" 
                @click="periodChanged(tab)"
              >
                {{ tab.title }}
              </div>
            </div>
          </div>

          <!-- 検索ボタン -->
          <PrimaryButton
            text="検索"
            class="button-contents mr-5"
            @click="getData()"
          >
          </PrimaryButton>

          <div class="text-white font-bold">
            {{ list.length }}件
          </div>

          <!-- リロードアイコン -->
          <Icon
            iconName="Refresh"
            :clickable="false"
            :class="{ 'animate-spin': loading }"
            class="text-white hover:text-gray-300 active:text-gray-400 ml-4 cursor-pointer" @click.native="refresh"
          />
        </div>
      </template>
      <template #page-header-content>
        <div class="flex justify-end">
          <div v-if="!boss&&!admin&&!auth" class="text-white font-bold mr-3 mt-auto">
            ※自分のデータのみ表示
          </div>
          <div v-else class="flex items-stretch">
            <!-- 切替 -->
            <div v-if="admin" class="flex items-center mr-2">
              <div class="cursor-pointer rounded-l text-sm font-bold py-1.5 h-8 text-center m-auto w-28" :class="filter.junior?'clickButtonColor4':'normalButtonColor'" @click="changeJunior('junior')">
                面談対象部下
              </div>
              <div class="cursor-pointer rounded-r text-sm font-bold py-1.5 h-8 text-center m-auto w-28" :class="filter.all?'clickButtonColor4':'normalButtonColor'" @click="changeJunior('all')">
                全員
              </div>
            </div>
            <div v-else-if="boss" class="flex items-center mr-2">
              <div class="cursor-pointer rounded text-sm font-bold py-1.5 h-8 text-center m-auto w-28" :class="filter.junior?'clickButtonColor4':'normalButtonColor'" @click="changeJunior('junior')">
                面談対象部下
              </div>
            </div>
            <div v-else-if="auth" class="flex items-center mr-2">
              <div class="cursor-pointer rounded text-sm font-bold py-1.5 h-8 text-center m-auto w-28" :class="filter.all?'clickButtonColor4':'normalButtonColor'" @click="changeJunior('all')">
                全員
              </div>
            </div>

            <!-- 名前検索 -->
            <div class="mr-2 mt-auto">
              <input
                type="search"
                name="filterUser" 
                placeholder="名前 検索"
                class="py-1 border border-gray-300 rounded-md leading-5 focus:bg-white focus:text-gray-900 h-8 w-36"
                v-model="filter.user"
              /> 
            </div>

            <!-- チャレンジ -->
            <div class="mr-2">
							<select
								v-model="filter.challenge"
								class="border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500 text-sm py-1.5 text-gray-700"
							>
								<option
									v-for="row in challengeList" :key="'cha'+row.id"
									:value="row.id"
								>
									{{ row.name }}
								</option>
							</select>
            </div>

            <!-- 昇格・降格 -->
            <div class="mr-2">
							<select
								v-model="filter.promotion"
								class="border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500 text-sm py-1.5 text-gray-700"
							>
								<option
									v-for="row in promotionList" :key='row.id'
									:value="row.id"
								>
									{{ row.name }}
								</option>
							</select>
            </div>

            <!-- 面談・確認 -->
            <div class="mr-2">
							<select
								v-model="filter.status"
								class="border-gray-300 rounded focus:ring-indigo-500 focus:border-indigo-500 text-sm py-1.5 text-gray-700"
							>
								<option
									v-for="row in statusList" :key='row.id'
									:value="row.id"
								>
									{{ row.name }}
								</option>
							</select>
            </div>

            <div v-if="boss||admin" class="text-white font-bold text-xs items-stretch my-auto">
              ※面談をする部下をクリックしてください。
            </div>
          </div>
        </div>
      </template>
    </PageHeader>

    <main class="absolute top-28 bottom-4 leading-8 w-full main-form mx-auto overflow-hidden">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full w-full">
        <div v-if="list.length" class="bg-white rounded-md overflow-auto h-full">

          <table class="text-sm w-full overflow-auto bg-white rounded-md border border-gray-200">

            <thead class="sticky top-0 z-50">
              <tr class="text-gray-500 text-sm">
                <th v-for="(c, i) in columns" :key="'col'+i" class="bg-colu p-2 border border-b-0 border-white" :class="c.class" :colspan="c.colspan" :rowspan="c.rowspan">{{ c.val }}</th>
              </tr>
              <tr class="text-gray-500 text-xs">
                <th v-for="(c, i) in columns2" :key="'col2'+i" class="bg-colu p-2 border border-b-0 border-white" :class="c.class" :colspan="c.colspan" :rowspan="c.rowspan">{{ c.val }}</th>
              </tr>
            </thead>

            <tbody v-for="(row, i) in list" :key="i">
              <tr class="hover-color cursor-pointer border-b" :class="setStyle(row, i)" @click="openModal(row)">
                <!-- グループ -->
                <td class="whitespace-nowrap text-sm text-gray-700 min-w-fit py-2 px-3 text-center">
                  {{ row.groupNum }}
                </td>

                <!-- 名前 -->
                <td class="whitespace-nowrap text-sm text-gray-700 min-w-fit py-2 px-3 text-center font-bold">
                  <div>{{ row.userName }}</div>
                  <div class="text-xs text-gray-400 mt-1 font-normal">{{ row.departmentName }}</div>
                </td>

                <!-- 賞与 -->
                <td class="whitespace-nowrap text-sm text-gray-700 min-w-fit py-2 px-3 text-center font-bold">
                  <div v-if="isDisp(row)">{{ row.bonusTotal.toLocaleString() }}</div>
                  <div v-else class="font-normal">非表示</div>
                </td>

                <!-- 前々期評価 -->
                <td class="whitespace-nowrap text-sm text-gray-600 min-w-fit py-2 px-3 text-center font-bold border-l" :class="setStyle2(row.rankName3)">
                  {{ row.rankName3 }}
                </td>

                <!-- 前々期昇格降格 -->
                <td class="whitespace-nowrap text-gray-700 min-w-fit py-2 px-3 text-center border-r">
                  <Badge v-if="row.promotion3" :color="statusColor[row.promotion3]">{{ row.promotionRes3 }}</Badge>
                </td>

                <!-- 前期評価 -->
                <td class="whitespace-nowrap text-sm text-gray-600 min-w-fit py-2 px-3 text-center font-bold border-l" :class="setStyle2(row.rankName2)">
                  {{ row.rankName2 }}
                </td>

                <!-- 前期昇格降格 -->
                <td class="whitespace-nowrap text-gray-700 min-w-fit py-2 px-3 text-center border-r">
                  <Badge v-if="row.promotion2" :color="statusColor[row.promotion2]">{{ row.promotionRes2 }}</Badge>
                </td>

                <!-- 今期評価 -->
                <td class="whitespace-nowrap text-sm text-gray-600 min-w-fit py-2 px-3 text-center font-bold bg-yellow-10" :class="setStyle2(row.rankName)">
                  <div v-if="isDisp(row)">{{ row.rankName }}</div>
                  <div v-else class="font-normal text-gray-600">非表示</div>
                </td>

                <!-- チャレンジ中 -->
                <td class="min-w-fit py-2 px-3 text-center border-l border-r border-white bg-yellow-10 text-red-700 font-bold">
                  <div v-if="row.challenge">中</div>
                  <div v-if="row.challenge&&row.challenge.indexOf('今期終了')>-1" class="text-xs">今期終了</div>
                </td>

                <!-- 昇格降格 -->
                <td class="whitespace-nowrap text-gray-700 min-w-fit py-2 px-3 text-center border-r bg-yellow-10">
                  <div v-if="isDisp(row)"><Badge v-if="row.promotion" :color="statusColor[row.promotion]">{{ row.promotionRes }}</Badge></div>
                  <div v-else class="font-normal text-gray-600">非表示</div>
                </td>

                <!-- 期ごとのトータル的な評価 -->
                <td v-if="columns.length==9" class="text-base text-gray-600 min-w-fit py-2 px-3 text-center font-bold bg-yellow-20 border-r-2 border-l-2 border-yellow-500" :class="setStyle2(row.grade)">
                  <div v-if="isDisp(row)">{{ row.grade }}</div>
                  <div v-else class="font-normal text-gray-600">非表示</div>
                </td>

                <!-- 面談 -->
                <td class="whitespace-nowrap text-xs min-w-fit py-2 px-3 text-center text-gray-700">
                  <div v-if="row.interviewDate&&row.changing1" class="font-bold text-red-700">賞与総額が変更になったため<br>再度面談をお願いします</div>
                  <div v-else-if="row.interviewDate" class="font-bold">{{ row.interviewDate }} </div>
                  <div>{{ row.interviewerName }}</div>
                </td>

                <!-- 確認 -->
                <td class="whitespace-nowrap text-xs min-w-fit py-2 px-3 text-center text-gray-700">
                  <div v-if="row.interviewCheck&&row.changing2" class="font-bold text-red-700">賞与総額が変更になったため<br>再度確認をお願いします</div>
                  <div v-else-if="row.interviewCheck" class="font-bold w-fit mx-auto">
                    <Icon slot="before" iconName="CheckCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else-if="!loading && !list.length && isCancel" class="w-full h-full flex justify-center items-center text-gray-400">
          <EmptyMessage
            iconName="PencilAlt"
            message="＊＊ただいま賞与金額を修正中です…確定するまでお待ちください＊＊"
          />
        </div>
        <div v-else-if="!loading && !list.length && isData" class="w-full h-full flex justify-center items-center text-gray-400">
          <EmptyMessage
            iconName="Document"
            message="該当するデータはありません。"
          />
        </div>
        <div v-else-if="!loading && !isData" class="w-full h-full flex justify-center items-center text-gray-400">
          <EmptyMessage
            iconName="ExclamationCircle"
            :message="filter.year + '年度 ' + periodName + ' の賞与はまだ確定していません。'"
          />
        </div>
      </div>
      <div class="text-transparent">{{reload}}</div>
    </main>

    <!-- 面談モーダル -->
    <BonusInterviewModal
      v-model="modalShow"
      :open="modalShow"
      :target="target"
      :rankCol="rankCol"
      @closed="closed"
    />
  </div>
</template>
  
<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import EmptyMessage from '@components/EmptyMessage.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import Badge from '@components/Badge.vue'
import * as backend from '@libs/backend'
import * as utils from '@libs/utils'
import * as moment from 'moment'
import * as dialogs from '@libs/dialogs'
import PageModel from '../../main/pages/PageModel.vue'
import BonusInterviewModal from '../components/BonusInterviewModal.vue'
import { PRESIDENT_ID } from '@/config'
import { FOUNDED } from '@/config'

const settionStrageName = 'bonusListStrage'

// 評価シート
const COL = [
  { val: 'グループ', class: 'text-center', rowspan: 2 },
  { val: '名前', class: 'text-center', rowspan: 2 },
  { val: '賞与総額', class: 'text-center', rowspan: 2 },
  { val: '前々期評価', class: 'text-center bg-green-50', colspan: 2 },
  { val: '前期評価', class: 'text-center bg-pink-50', colspan: 2 },
  { val: '今期評価', class: 'text-center bg-yellow-200', colspan: 3 },
  { val: '総合評価', class: 'text-center bg-yellow-300 whitespace-pre-line', rowspan: 2 },
  { val: '面談完了', rowspan: 2 },
  { val: '部下確認', rowspan: 2 },
]

export default {
  extends: PageModel,
  components: {
    Icon,
    PageHeader,
    EmptyMessage,
    PrimaryButton,
    Badge,
    // LoadingIcon,
    BonusInterviewModal
  },

  computed: {
    /**
     * スマホ
     */
    isMobileDevice() {
      return utils.deviceInfo.isMobile
    },

    /**
     * タブレット
     */
    isTabletDevice() {
      return utils.deviceInfo.isTablet
    },

    /**
     * ログインユーザーID
     */
    userId () {
      return this.$store.getters.user.id
    },

    /**
     * 自分のデータ表示有無
     */
    isDisp() {
      return (row) => {
        if (row) {
          // 自分のデータの場合
          if (row.userId == this.userId) {
            // 完了しているならOK
            if (row.interviewCheck && !row.changing2) {
              return true
            }
            return false
          } else {
            return true
          }
        }
        return false
      }
    },

    /**
     * 日付フォーマット
     */
    dateFormat() {
      return (tar) => {
        if (tar) {
          return '（' + moment(tar).format('M/D HH:mm') + '）'
        }
        return ''
      }
    }
  },

  data() {
    return {
      loading: false,
      reload: 0,
      // 切替ボタン
      periodList: [
        { id: 1, title: '上期' },
        { id: 2, title: '下期' }
      ],
      period: 1,
      periodName: '上期',
      // リスト
      list: [],
      // カラム
      columns: utils.clone(COL),
      columns2: [
        { val: '評価', class: 'text-center bg-green-50' },
        { val: '面談結果', class: 'text-center bg-green-50' },
        { val: '評価', class: 'text-center bg-pink-50' },
        { val: '面談結果', class: 'text-center bg-pink-50' },
        { val: '評価', class: 'text-center bg-yellow-200' },
        { val: 'チャレンジ', class: 'text-center bg-yellow-200' },
        { val: '面談結果', class: 'text-center bg-yellow-200' }
      ],
      rankCol: [],
      // 検索条件
      filter: {
        // 年度
        year: null,
        // 対象者絞込み
        user: '',
        // 部下全員,
        junior: false,
        // 全員
        all: false,
        // チャレンジ中
        challenge: null,
        // 昇格・降格
        promotion: null,
        // 面談、確認
        status: null
      },
      // 昇格、降格カラー
      statusColor: {
        1: 'blueGray',
        2: 'blue2',
        3: 'lightGreen',
        4: 'green',
        5: 'orange',
        6: 'gray',
        7: 'orange',
        8: 'orange'
      },
      // チャレンジ
      challengeList: [
        { id: null, name: 'チャレンジ有無 全て' },
        { id: 'c2', name: 'チャレンジ中' },
        { id: 'c3', name: 'チャレンジ無' },
      ],
			// 昇格・降格候補
			promotionList: [
				{ id: null, name: '昇格・降格 全て' },
				{ id: 1, name: '昇格チャレンジ（未定）' },
				{ id: 2, name: '昇格チャレンジ 確定' },
				{ id: 3, name: '昇格（未定）' },
				{ id: 4, name: '昇格 確定' },
				{ id: 5, name: '拒否' },
				{ id: 6, name: '降格' },
				{ id: -1, name: '無し以外全て' },
			],
      // 状態リスト
      statusList: [
        { id: null, name: '完了・未完了 全て' },
        { id: 1, name: '未完了' },
        { id: 2, name: '完了' }
      ],
      // 上司フラグ
      boss: false,
      // 管理者権限あり
      admin: false,
      // 賞与画面権限あり
      auth: false,
      // 今期データの有無
      isData: false,
      // 解除中
      isCancel: false,
      // 面談対象データ
      target: {},
      // 面談モーダル
      modalShow: false,
      // 期
      term: null,

      interval: null
    }
  },

  mounted() {
    // 100秒おきに反映
    this.interval = setInterval(() => {
      if (!this.modalShow) {
        this.getData()
      }
    }, 100000)
  },

  destroyed() {
    // 100秒おきの反映終了
    clearInterval(this.interval)
  },

  async created() {
    // ユーザー情報
    const user = this.$store.getters.loginUserData
    // 上司フラグ
    const bossFlg = user.boss
    const group = user.groupNum
    if (bossFlg && group && group >= 5) {
      this.boss = true

    // 橋本社長の場合
    } else if (String(PRESIDENT_ID) == String(user.userId)) {
      this.boss = true
    }

    let auth = this.$store.getters.auth
    // 管理者権限
    if (auth && auth.adminAuth) {
      this.admin = true
      this.boss = true
    // 管理者権限はなく、賞与画面権限あり
    } else if (auth && auth.bonusAuth) {
      this.auth = true
    }

    if (this.boss) {
      this.filter.junior = true
    } else {
      this.filter.junior = false
      this.filter.all = false
    }

    // 年度
    this.filter.year = Number(moment().format('YYYY'))
    const mm = Number(moment().format('M'))
    if (mm == 1) {
      this.filter.year--
      this.period = 2
    } else if (mm <= 7) {
      this.period = 1
    } else {
      this.period = 2
    }
    // 基本的に前の期を表示
    if (this.period == 1) {
      // 去年度の後期
      this.filter.year--
      this.period = 2
    } else {
      // 今年度の前期
      this.period = 1
    }
    this.getSettionStrage()
    await this.getData()
    if (!this.boss && !this.admin && this.list.length == 1) {
      this.openModal(this.list[0])
    }
  },

  methods: {
    /**
     * データ取得
     */
    async getData() {
      if (!this.filter.year) {
        await dialogs.showErrorDialog('年度を入力してください', '画面右上の「年度」に表示したい年度を入力してください。')
        return
      }

      if (!this.period || this.period < 1 || this.period > 2 ) {
        await dialogs.showErrorDialog('期を選択してください', '画面右上の「期」を選択してください。')
        return
      }

      this.term = Number(this.filter.year) - FOUNDED

      // データ取得
      this.loading = true

      this.getPeriodName()

      // カナを削除したログインユーザー名、ユーザーID
      const loginUser = utils.deleteKana(this.$store.getters.user.user_name)
      const loginUserId = this.$store.getters.user.id
      const res = await backend.postData('evaluationBonusResult/getList', { ...this.filter, loginUser, loginUserId, period: this.period, boss: this.boss, admin: this.admin, auth: this.auth })
      // 解除中
      if (res.data.data && res.data.data.cancel) {
        this.list = []
        this.isData = true
        this.isCancel = true
        this.rankCol = []
      } else if (res.data.data) {
        this.list = res.data.data.list
        this.isData = res.data.data.isData
        this.isCancel = false
        this.rankCol = res.data.data.col
      } else {
        this.list = []
        this.isData = false
        this.isCancel = false
        this.rankCol = []
      }

      const columns = utils.clone(COL)

      if (this.rankCol && this.rankCol.length) {  
        for (let i = 0; i < this.columns.length; i++) {
          let c = columns[i]
          if (c.val == '前々期評価' && this.rankCol[0]) {
            c.val = this.rankCol[0]
          } else if (c.val == '前期評価' && this.rankCol[1]) {
            c.val = this.rankCol[1]
          } else if (c.val == '今期評価' && this.rankCol[2]) {
            c.val = this.rankCol[2]
          } else if (c.val == '総合評価') {
            if (this.period == 2) {
              c.val = this.term + '期\n総合評価'
              delete c.disabled
            } else {
              c.disabled = true
            }
          }
        }
      }

      this.columns = columns.filter((c) => {
        return !c.disabled
      })

      this.setSessionStorage()
      this.loading = false
    },

    /**
     * 切替イベント
     * @paran tab 選択したタブ
     */
    async periodChanged(tab) {
      this.period = tab.id
      await this.getData()
    },

    /**
     * 期の名前
     */
    getPeriodName() {
      this.periodName = this.periodList.find((p) => {
        return p.id == Number(this.period)
      }).title
    },

    /**
     * グループの境目は線を太くする
     */
    setStyle(row, i) {
      let border = ''
      if (i != this.list.length - 1 && row.groupNum != this.list[i+1].groupNum) {
        border = 'border-b-4 border-blue-100'
      }
      return border
    },

    /**
     * 表示切替
     */
    changeJunior(val) {
      if (this.filter[val]) {
        this.filter[val] = false
      } else {
        this.filter.junior = false
        this.filter.all = false

        this.filter[val] = true
      }
      this.getData()
    },

    /**
     * 評価の色
     */
    setStyle2(val) {
      if (val == 'A') {
        return 'text-yellow-600'
      }
      if (val == 'B') {
        return 'text-green-600'
      }
      if (val == 'S') {
        return 'text-indigo-600'
      }
      if (val == 'SS') {
        return 'text-pink-700'
      }
    },

    /**
     * 面談モーダルopen
     */
    openModal(row) {
      this.target = row
      this.modalShow = true
    },

    /**
     * 面談モーダルclose
     */
    closed() {
      this.modalShow = false
      this.getData()
    },

    /**
     * リフレッシュアイコンイベント
     */
    async refresh() {
      await this.getData()
    },

    /**
     * セッションストレージ取得
     */
    getSettionStrage() {
      const searchJson = sessionStorage.getItem(settionStrageName)
      const getItem = JSON.parse(searchJson)
      if (getItem) {
        if (getItem.period) {
          this.period = getItem.period
        }
        delete getItem.period
        this.filter = getItem
        if (this.filter.junior && this.filter.all) {
          this.filter.junior = true
          this.filter.all = false
        }

        if (!this.boss) {
          this.filter.junior = false
          this.filter.all = false
        }
        if (!this.admin) {
          this.filter.all = false
        }
      }
    },

    /**
     * セッションストレージ保存
     */
    setSessionStorage() {
      const searchStr = JSON.stringify({ ...this.filter, period: this.period })
      sessionStorage.setItem(settionStrageName, searchStr)
    },
  }
}
</script>
  
<style scoped>
.main-form {
  min-width: 880px;
}

.table-h {
  max-height: calc(100% - 3px);
}

.table {
  width: 100%;
}

.bg-colu {
  background: #ebf0fb;
}

.hover-color {
  background: white;
}

.hover-color:hover {
  background: rgb(239, 250, 250) !important;
}

.bg-yellow-10 {
  background: rgb(255 246 229 / 44%);
}

.bg-yellow-20 {
  background: rgba(248, 230, 196, 0.44);
}
</style>